
export default [
    {
        path: '/app/contacts',
        name: 'app.contacts',
        components: {
            authenticated: () => import(/* webpackChunkName: "app-contacts" */ './../views/App/Contacts/Dashboard.vue')
        },
        meta: {
            auth: true,
            permition: ['S', 'A', 'C', 'U']
        }
    },
    {
        path: '/app/contacts/contacts',
        name: 'app.contacts.contacts',
        components: {
            authenticated: () => import(/* webpackChunkName: "app-contacts-contacts" */ './../views/App/Contacts/Contacts/Index.vue')
        },
        meta: {
            auth: true,
            permition: ['S', 'A', 'C', 'U']
        }
    },
    {
        path: '/app/contacts/contacts/create',
        name: 'app.contacts.contacts.create',
        components: {
            authenticated: () => import(/* webpackChunkName: "app-contacts-contacts-create" */ './../views/App/Contacts/Contacts/Create.vue')
        },
        meta: {
            auth: true,
            permition: ['S', 'A', 'C', 'U']
        }
    },
    {
        path: '/app/contacts/contacts/edit/:id',
        name: 'app.contacts.contacts.edit',
        components: {
            authenticated: () => import(/* webpackChunkName: "app-contacts-contacts-edit" */ './../views/App/Contacts/Contacts/Edit.vue')
        },
        meta: {
            auth: true,
            permition: ['S', 'A', 'C', 'U']
        }
    },
    {
        path: '/app/contacts/groups',
        name: 'app.contacts.groups',
        components: {
            authenticated: () => import(/* webpackChunkName: "app-contacts-groups" */ './../views/App/Contacts/Groups/Index.vue')
        },
        meta: {
            auth: true,
            permition: ['S', 'A', 'C', 'U']
        }
    },
    {
        path: '/app/contacts/groups/create',
        name: 'app.contacts.groups.create',
        components: {
            authenticated: () => import(/* webpackChunkName: "app-contacts-groups-create" */ './../views/App/Contacts/Groups/Create.vue')
        },
        meta: {
            auth: true,
            permition: ['S', 'A', 'C', 'U']
        }
    },
    {
        path: '/app/contacts/groups/edit/:id',
        name: 'app.contacts.groups.edit',
        components: {
            authenticated: () => import(/* webpackChunkName: "app-contacts-groups-edit" */ './../views/App/Contacts/Groups/Edit.vue')
        },
        meta: {
            auth: true,
            permition: ['S', 'A', 'C', 'U']
        }
    },
    {
        path: '/app/contacts/import',
        name: 'app.contacts.import',
        components: {
            authenticated: () => import(/* webpackChunkName: "app-contacts-import" */ './../views/App/Contacts/Import/Index.vue')
        },
        meta: {
            auth: true,
            permition: ['S', 'A', 'C', 'U']
        }
    },
    {
        path: '/app/contacts/import/create',
        name: 'app.contacts.import.create',
        components: {
            authenticated: () => import(/* webpackChunkName: "app-contacts-import-create" */ './../views/App/Contacts/Import/Create.vue')
        },
        meta: {
            auth: true,
            permition: ['S', 'A', 'C', 'U']
        }
    },
    {
        path: '/app/contacts/blocks',
        name: 'app.contacts.blocks',
        components: {
            authenticated: () => import(/* webpackChunkName: "app-contacts-blocks" */ './../views/App/Contacts/Blacklist/Index.vue')
        },
        meta: {
            auth: true,
            permition: ['S', 'A', 'C', 'U']
        }
    }
]
